import { axiosClient } from '../../clients/axios-client'
import { type FileInfoType, type FileParsingStatus } from '../../types'
import type { FileDto, FilePoolResponseFilesDto } from './dtos/file'
import { FilePoolResponseFilesDtoSchema } from './dtos/file'

export async function getFilePool() {
  try {
    const { data } = await axiosClient.get<FilePoolResponseFilesDto>('/filepool/files')
    const parsedData: FilePoolResponseFilesDto = FilePoolResponseFilesDtoSchema.parse(data)

    const response: FileInfoType[] = parsedData.files.map((file: FileDto) => {
      const { file_id, filename, file_type, parsing_status, uploaded_at, expires_at, is_excluded } =
        file

      return {
        id: file_id,
        name: filename,
        type: file_type,
        parsingStatus: parsing_status as FileParsingStatus,
        uploadedAt: uploaded_at,
        expiresAt: expires_at,
        isExcluded: is_excluded ?? false,
      }
    })

    const parsedFiles = response.filter((file) => file.parsingStatus === 'completed')

    // order by uploaded date, most recent first
    return parsedFiles.sort((a, b) => {
      const dateA = new Date(a.uploadedAt ?? '')
      const dateB = new Date(b.uploadedAt ?? '')
      return dateB.getTime() - dateA.getTime()
    })
  } catch (error) {
    console.error('Error getting filepool', error)
    throw error
  }
}
